import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  navbg:0,
	  twoid:0,
	  meetingbt:0,
	  buslbt:0,
	  id:{},
  },
  mutations: {
	  liuxing(state,id){//监听
		  state.id = id
	  },
	  navbgshow(state,ids){ //首页导航背景图切换状态
	  	state.navbg = ids
	  },
	  navbgid(state,id){ //首页二级跳三级id心血管 
	  	state.twoid = id
	  },
	  meetingshow(state,id){ //首页左边的封装
	  	state.meetingbt = id
	  },
	  business(state,id){ //商务合作轮播图的显示
	  	state.buslbt = id
	  },
  },
  actions: {
  },
  modules: {
  }
})
